var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.62973 0.736393C5.40561 0.469584 5.19216 0.22412 5.00006 0C4.80796 0.234792 4.59451 0.480256 4.37039 0.736393C3.015 2.29456 1.14734 4.46105 1.14734 6.14728C1.14734 7.21451 1.57423 8.17503 2.27861 8.86873C2.97231 9.56243 3.93282 10 5.00006 10C6.0673 10 7.02781 9.57311 7.72151 8.86873C8.41522 8.17503 8.85278 7.20384 8.85278 6.14728C8.85278 4.46105 6.98512 2.30523 5.62973 0.736393ZM5.02141 9.12487C4.22098 9.12487 3.48459 8.79402 2.96164 8.27108C2.43869 7.74813 2.10785 7.01174 2.10785 6.21131C2.09718 6.0619 2.22525 5.9445 2.37466 5.9445C2.52407 5.9445 2.64147 6.0619 2.64147 6.21131C2.64147 6.873 2.90828 7.45998 3.33517 7.89755C3.76207 8.32444 4.35972 8.59125 5.02141 8.59125C5.17082 8.59125 5.28821 8.70864 5.28821 8.85806C5.28821 9.00747 5.17082 9.12487 5.02141 9.12487Z",
    fill: "#54AFE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.cceb486fe1f26063bde712aa9fd7ea1e.svg";
export { ForwardRef as ReactComponent };